<template>
  <div :class="'flex flex-col ' + size">
    <slot name="label">
      <label :for="props.name" :class="props.classes">{{ label }}</label>
    </slot>
    <slot>
      <Select
        :name="props.name"
        :id="props.name"
        type="text"
        :options="props.type"
        optionLabel="display"
        optionValue="value"
        :placeholder="placeholder"
        :showClear="showClear"
        :disabled="disabled"
        v-model="value"
        class="h-10"
      ></Select>
      <small v-if="errorMessage" :id="props.name + '-help'" class="text-danger-500">{{ errorMessage }}</small>
    </slot>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate";

interface Props {
  name: string;
  value?: string;
  label: string;
  size?: string;
  classes?: string;
  placeholder?: string;
  showClear?: boolean;
  disabled?: boolean;
  type?: Option[];
}
const props = withDefaults(defineProps<Props>(), {
  size: "w-full",
  classes: "font-bold",
  placeholder: " ",
  showClear: false,
  disabled: false,
});

export type Option = {
  display: string;
  value: string | number;
};

const { value, errorMessage } = useField<string | number>(() => props.name);
</script>
